import React from 'react';
import {IconComponent} from "../../reusable/simpleComponents";
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {LayoutState} from "../../../store/layouts/types";
import {triggerAcknowledgeTable} from "../../../store/layouts/actions";
import { AlertState } from '../../../store/alerts/types';

const AcknowledgeUIEventIconComponent = () => {
    const dispatch = useDispatch();
    const { acknowledgeFormIsOpened } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const { selectedEvent } = useSelector<ApplicationState, AlertState>(state => state.alerts);

    return (
        <IconComponent
            classValue={'acknowledge icon'}
            handler={() => dispatch(triggerAcknowledgeTable(!acknowledgeFormIsOpened))}
            title="Acknowledge Event"
            disable={selectedEvent ? false : true}
        />
    );
};

export default AcknowledgeUIEventIconComponent;